module.exports = __webpack_public_path__ + "img/bethlehem-zoom-01.341bbd60.png";